import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';
import { IPartValue } from 'quotes/types';

export const addPartLineSchema = () =>
  yup.object({
    part: yup
      .object({
        number: yup.string().label(t('labelPartNumber')).nullable(),
      })
      .label(t('labelPartNumber'))
      .nullable(),
    manufacturer: yup.object().label(t('labelManufacturer')).nullable(),
    description: yup
      .string()
      .label(t('labelDescription'))
      .nullable()
      .when('part', {
        is: (part: IPartValue) => !part?.verified,
        then: yup
          .string()
          .nullable()
          .required(getEmptyErrorMessage(t('labelDescription'))),
      }),
    quantity: numberSchemaWithTransform()
      .label(t('labelQuantity'))
      .min(0, t('labelQuantity'))
      .required(getEmptyErrorMessage(t('labelQuantity'))),
    uom: yup
      .string()
      .label(t('labelUom'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelUom'))),
  });
